<div class="phone-frame">
  <img class="phone-image" [src]="phone.picture" [alt]="phone.name" />
  <div class="caption">
    <div class="phone-name">{{ phone.name }}</div>
  </div>
  <button class="btn-action" mat-flat-button color="primary" (click)="onExport()">Xuất ảnh</button>
</div>